export enum InvitePageViewKind {
  Loading = "loading",
  Ready = "ready",
  Expired = "expired",
  AlreadyUsed = "already-used",
  NotFound = "not-found",
  Error = "error",
}
